import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ChangelogToggle } from './components/toggle-button';
import { Changelog } from './changelog-loadable';
import { ChangelogWrapper, ChangelogModal } from './styles';
import type { AppState } from '../../reducers';

const selectChangelogOpen = (state: AppState) => state.areas.changelog.isOpen;
const selectChangelogArticles = (state: AppState) =>
  state.areas.changelog.articles;

const ChangelogDesktop = () => {
  const dispatch = useDispatch();
  const articles = useSelector(selectChangelogArticles);
  const isOpen = useSelector(selectChangelogOpen);
  const toggleOpen = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();

      dispatch({ type: 'CHANGELOG_TOGGLE' });
    },
    [dispatch]
  );

  if (!articles || !articles.length) {
    return null;
  }

  return (
    <ChangelogWrapper>
      <ChangelogToggle onClickHandler={toggleOpen} />

      {isOpen && (
        // Conditionally render this to not load the extra bundle on pageload
        <ChangelogModal visible={isOpen}>
          <Changelog />
        </ChangelogModal>
      )}
    </ChangelogWrapper>
  );
};

export default ChangelogDesktop;
